import script from "./footnote-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./footnote-editor.vue?vue&type=script&setup=true&lang=js"

import "./footnote-editor.vue?vue&type=style&index=0&id=9e55034e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e55034e"]])

export default __exports__